// ===========================================================================
// No Recent Visits — módulo independiente.
//
// Lista de priorización de pacientes según el tiempo desde su última visita
// médica. Header con 4 KPI tiles (Total Members, donut de Networks, donut de
// Time Since, PCP Count), filtros (búsqueda + panel + donuts clickeables) y
// tabla paginada server-side. Controlador backend: /api/no-recent-visits.
//
// Reemplaza al tool legacy en /NoRecentVisit (eliminado).
// ===========================================================================
import NoRecentVisitsPage from "./pages/NoRecentVisitsPage";

export const noRecentVisitRoutes = [
  { path: "/no-recent-visits", element: <NoRecentVisitsPage /> },
];

export { default as NoRecentVisitsPage } from "./pages/NoRecentVisitsPage";
export * from "./services";
export default NoRecentVisitsPage;
